import { render, staticRenderFns } from "./linkPager.vue?vue&type=template&id=819f63b4&"
import script from "./linkPager.vue?vue&type=script&lang=js&"
export * from "./linkPager.vue?vue&type=script&lang=js&"
import style0 from "./linkPager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports